import { provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZecnZXRmheUEJ/W0ZWYE0=');

const skipPaths = ['/', '/login', '/login-failed', '/logout', '/unauthorized', '/unavailable', '/dashboard', '/home'];
const currentPath = window.location.pathname;
if (!skipPaths.includes(currentPath)) {
  sessionStorage.setItem('of_return_url', currentPath + window.location.search);
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZonelessChangeDetection(), ...appConfig.providers]
}).catch((err) => console.error(err));
